var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 18.023"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.171 17.926L6 14.429.835 17.922c-.325.22-.835.042-.835-.291V.769C0 .344.447 0 .998 0h9.999C11.551 0 12 .346 12 .772v16.865c0 .331-.506.508-.829.289z"
  })));
}

export default SvgBookmarkIcon;